import { generateId } from "../../../idGenerator";
import { PYTHON_BACKEND_URL } from "@carousel-office/shared";
function normalizeBaseUrl(baseUrl) {
    return baseUrl.replace(/\/+$/, "");
}
async function fetchBatchFromBackend(queries, backendBaseUrl) {
    const response = await fetch(`${normalizeBaseUrl(backendBaseUrl)}/alphasense/search/batch`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ queries }),
    });
    if (!response.ok) {
        throw new Error(`AlphaSense API error (${response.status}): ${await response.text()}`);
    }
    return (await response.json());
}
function defaultContextIdFactory() {
    return generateId("as", 6);
}
function dedupeCitations(citations) {
    const byKey = new Map();
    for (const citation of citations) {
        const key = `${citation.id}|${citation.url}`;
        if (!byKey.has(key)) {
            byKey.set(key, citation);
        }
    }
    return Array.from(byKey.values());
}
export function buildAlphaSenseSearchResponse(batchResponse, createContextId = defaultContextIdFactory) {
    const chunkIdMap = {};
    const allChunks = [];
    const allCitations = [];
    const queryResults = batchResponse.results.map((result) => {
        const chunksWithIds = result.chunks.map((chunk) => {
            const contextId = createContextId();
            const chunkWithId = { ...chunk, contextId };
            chunkIdMap[contextId] = chunkWithId;
            allChunks.push(chunkWithId);
            return chunkWithId;
        });
        allCitations.push(...result.citations);
        return {
            query: result.query,
            chunks: chunksWithIds,
            citations: result.citations,
            conversation_id: result.conversation_id,
            error: result.error,
        };
    });
    return {
        queryResults,
        chunks: allChunks,
        citations: dedupeCitations(allCitations),
        chunkIdMap,
        stats: {
            totalQueries: batchResponse.total_queries,
            successfulQueries: batchResponse.successful_queries,
            failedQueries: batchResponse.failed_queries,
        },
    };
}
export async function executeAlphaSenseSearch(queries, options = {}) {
    if (!queries.length) {
        throw new Error("At least one AlphaSense query is required.");
    }
    const executeBatch = options.executeBatch ||
        ((items) => fetchBatchFromBackend(items, options.backendBaseUrl || PYTHON_BACKEND_URL));
    const batchResponse = await executeBatch(queries);
    return buildAlphaSenseSearchResponse(batchResponse, options.createContextId || defaultContextIdFactory);
}
